var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D7F3DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7493 20.9167C11.7493 18.6708 13.3627 16.8192 15.4893 16.4158L14.1235 17.7908L15.416 19.0833L19.0827 15.4075L15.416 11.75L14.1235 13.0425L15.5718 14.4908V14.5458C14.0135 14.7333 12.5778 15.4849 11.5358 16.6587C10.4937 17.8324 9.91755 19.3471 9.91602 20.9167C9.91602 24.4642 12.7852 27.3333 16.3327 27.3333H19.0827V25.5H16.3327C13.8027 25.5 11.7493 23.4467 11.7493 20.9167ZM20.916 20.9167V27.3333H29.166V20.9167H20.916ZM27.3327 25.5H22.7493V22.75H27.3327V25.5ZM20.916 12.6667H29.166V19.0833H20.916V12.6667Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.0e177317df4118aa3e8b7cf016115894.svg";
export { ForwardRef as ReactComponent };